import React from 'react'
import { motion } from 'framer-motion'
import { MonthlyUsage, StatsCards, ApiKeysSection, QuickStartSection } from './index'

const OverviewTab = ({
  quota,
  plan,
  allApiKeys,
  filteredAndSortedApiKeys,
  showRevokedKeys,
  setShowRevokedKeys,
  handleCreateApiKey,
  handleRevokeApiKey,
  createApiKeyMutation,
  revokingKeyId,
  copyToClipboard,
  setActiveTab,
  userInfo
}) => {
  return (
    <div>
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">Account Overview</h2>
        <p className="text-gray-600">Monitor your API usage, manage keys, and access documentation</p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <MonthlyUsage quota={quota} />
        
        <StatsCards plan={plan} allApiKeys={allApiKeys} />

        <ApiKeysSection
          allApiKeys={allApiKeys}
          filteredAndSortedApiKeys={filteredAndSortedApiKeys}
          showRevokedKeys={showRevokedKeys}
          setShowRevokedKeys={setShowRevokedKeys}
          handleCreateApiKey={handleCreateApiKey}
          handleRevokeApiKey={handleRevokeApiKey}
          createApiKeyMutation={createApiKeyMutation}
          revokingKeyId={revokingKeyId}
          userInfo={userInfo}
          copyToClipboard={copyToClipboard}
        />

        <QuickStartSection copyToClipboard={copyToClipboard} setActiveTab={setActiveTab} userInfo={userInfo} />
      </motion.div>
    </div>
  )
}

export default OverviewTab
